
import { api_experiment } from "@/services/iot/api_experiment";
const apiService = new api_experiment(process.env.VUE_APP_BASE_URL);
import { api_general } from "@/services/iot/api_general";
const apiGeneral = new api_general(process.env.VUE_APP_BASE_URL);
export default {
  data: () => ({
    setup_dialog: false,
  }),
  methods: {
    popSetup() {
      this.setup_dialog = true;
    },
    setExperimentOverrideOn(callback) {
      var self = this;
      apiService
        .setExperimentOverrideOn(
          self.$store.state.current.school_id,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
        )
        .then((response) => {
          self.checkOverrided();
        });
    },
    setExperimentOverrideOff(callback) {
      var self = this;
      apiService
        .setExperimentOverrideOff(
          self.$store.state.current.school_id,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
        )
        .then((response) => {
          self.checkOverrided();
        });
    },
    getSetupPhoto(){
      var self = this;
      apiService
        .getSetupPhoto(
          self.$cookies.get('school_id'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            self.setup_photos = response.photos;
          }
        });
    },
    getLabManual(){
      var self = this;
      apiService
        .getLabManual(
          self.$cookies.get('school_id'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            //window.open(response.filename);
            self.lab_manual.school_chi = response.school_chi;
            self.lab_manual.school_en = response.school_en;
            self.lab_manual.suggested_chi = response.suggested_chi;
            self.lab_manual.suggested_en = response.suggested_en;
            console.log(self.lab_manual.school_chi,self.lab_manual.school_en,self.lab_manual.suggested_chi,self.lab_manual.suggested_en );
          }
        });
    },
    getExperimentVideoDemo(){
      var self = this;
      apiService
        .getExperimentVideoDemo(
          self.$cookies.get('school_id'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            //window.open(response.filename);
            self.video_demo.school_chi = response.school_chi;
            self.video_demo.school_en = response.school_en;
            self.video_demo.suggested_chi = response.suggested_chi;
            self.video_demo.suggested_en = response.suggested_en;
            console.log(self.video_demo.school_chi,self.video_demo.school_en,self.video_demo.suggested_chi,self.video_demo.suggested_en );
          }
        });
    },
    checkBookingEnd() {
      var self = this;
      apiService
        .checkBookingEnd(
          self.$cookies.get('booking_id'),
          self.$cookies.get('school_id'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            if(response.exceed){
              alert("This Booking is end. You are forced leaving from this experiment page.");
              clearInterval(self.inte);
              self.$cookies.remove('booking_id');
              
              self.$router.push(
                "/booking/" + self.school_id
              );
            }
            else if(!response.exceed){
            }
          }
          else {
            alert("Error in retrieving data. Please re-enter experiment via Booking Page.");
              clearInterval(self.inte);              
              self.$router.push(
                "/booking/" + self.school_id
              );
          }
        });
    },
    getValue(device_id, callback) {
      var self = this;
      apiService
        .getValue(
          self.$cookies.get("session_token"),
          self.$cookies.get("role"),
          self.$store.state.current.school_id,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
        )
        .then((response) => {
          if(response.status=="fail"){
            self.$store.commit("showSnackBar", response.error);
          }
          else{
            self.api.value_got_at = response.value_got_at;
            self.api.value_set_at = response.value_set_at;
            self.api.command_got_at = response.command_got_at;
            self.api.command_set_at = response.command_set_at;
            if (response.value != '') {
              self.api.value = JSON.parse(response.value);
            }
            if (callback) {
              callback();
            }
          }
        });
    },
    getChart(device_id) {
      var self = this;
      apiService
        .getChart(
          self.$cookies.get("session_token"),
          self.$cookies.get("role"),
          self.$store.state.current.school_id,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
        )
        .then((response) => {
          self.api.chart = response;
          self.series = [{ data: response }];
          self.loading = false;
        });
    },    
    getChartMultiple(device_id, no_of_data, data1, data2='') {
      var self = this;
      if(no_of_data == 0){
        self.series = [ { name: "", data: [] } ];
        self.series_chi = [ { name: "", data: [] } ];
        self.options.yaxis = {
          title: {
            text: ""
          },
        };
        self.options_chi.yaxis = {
          title: {
            text: ""
          },
        };
        if(self.$i18n.locale == 'tc'){
          self.$refs.realtimeChart.updateSeries(self.series_chi, false);
          self.$refs.realtimeChart.updateOptions(self.options_chi);
        }
        else {
          self.$refs.realtimeChart.updateSeries(self.series, false);
          self.$refs.realtimeChart.updateOptions(self.options);
        }
        return ;
      }
      apiService
        .getChartMultiple(
          self.$cookies.get("session_token"),
          self.$cookies.get("role"),
          self.$store.state.current.school_id,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
          no_of_data,
          data1,
          data2
        )
        .then((response) => {
          self.api.chart = response;
          self.data_1.data_max = response.data_1_max;
          self.data_1.data_min = response.data_1_min;
          self.data_2.data_max = response.data_2_max;
          self.data_2.data_min = response.data_2_min;
          if(no_of_data==1){
            console.log(self.data_1, self.data_2);
            self.series = [{ name: self.graph_names[data1], data: response.data_1 }];
            self.series_chi = [{ name: self.graph_chi_names[data1], data: response.data_1 }];
            self.options.yaxis = {
              title: {
                text: self.graph_names[data1]+" ("+ self.graph_units[data1] +")"
              },
            };
            self.options_chi.yaxis = {
              title: {
                text: self.graph_chi_names[data1]+" ("+ self.graph_units[data1] +")"
              },
            };
            if(self.manual_yaxis){
              if(isNaN(self.data_1.manual_max) || isNaN(self.data_1.manual_min)) {
                self.options.yaxis.max=undefined;
                self.options.yaxis.min=undefined;
                self.options_chi.yaxis.max=undefined;
                self.options_chi.yaxis.min=undefined;
              }
              else {
                self.options.yaxis.max=parseFloat(self.data_1.manual_max);
                self.options.yaxis.min=parseFloat(self.data_1.manual_min);
                self.options_chi.yaxis.max=parseFloat(self.data_1.manual_max);
                self.options_chi.yaxis.min=parseFloat(self.data_1.manual_min);
              }
            }
            else {
              self.data_1.manual_max = undefined;
              self.data_1.manual_min = undefined;
              self.data_2.manual_max = undefined;
              self.data_2.manual_min = undefined;
            }
            setTimeout(function(){
              if(response.data_1==null) {
                self.series = [ { name: "", data: [] } ];
                self.series_chi = [ { name: "", data: [] } ];
              }
              if(self.$i18n.locale == 'tc'){
                self.$refs.realtimeChart.updateSeries(self.series_chi, false);
                self.$refs.realtimeChart.updateOptions(self.options_chi);
              }
              else {
                self.$refs.realtimeChart.updateSeries(self.series, false);
                self.$refs.realtimeChart.updateOptions(self.options);
              }
              self.loading = false;
            },500)
          }
          else if(no_of_data==2){
            self.options.yaxis= [
              {
                max: response.data_1_max,
                min: response.data_1_min,
                title: {
                  text: self.graph_names[data1]+" ("+ self.graph_units[data1] +")",
                  style: {
                    color: '#FF0000',
                  }
                },
              },
              {
                max: response.data_2_max,
                min: response.data_2_min,
                opposite: true,
                title: {
                  text: self.graph_names[data2]+" ("+ self.graph_units[data2] +")",
                  style: {
                    color: '#0000FF',
                  }
                },
              },
            ];
            self.options_chi.yaxis= [
              {
                max: response.data_1_max,
                min: response.data_1_min,
                title: {
                  text: self.graph_chi_names[data1]+" ("+ self.graph_units[data1] +")",
                  style: {
                    color: '#FF0000',
                  }
                },
              },
              {
                max: response.data_2_max,
                min: response.data_2_min,
                opposite: true,
                title: {
                  text: self.graph_chi_names[data2]+" ("+ self.graph_units[data2] +")",
                  style: {
                    color: '#0000FF',
                  }
                },
              },
            ];
            self.series= [
              { name: self.graph_names[data1], data: [],},
              { name: self.graph_names[data2], data: [],}
            ];
            
            self.series_chi= [
              { name: self.graph_chi_names[data1], data: [],},
              { name: self.graph_chi_names[data2], data: [],}
            ];
            if(self.manual_yaxis){
              if(isNaN(self.data_1.manual_max)) ;
              else {
                self.options.yaxis[0].max = parseFloat(self.data_1.manual_max);
                self.options_chi.yaxis[0].max = parseFloat(self.data_1.manual_max);
              }              
              if(isNaN(self.data_1.manual_min)) ;
              else {
                self.options.yaxis[0].min = parseFloat(self.data_1.manual_min);
                self.options_chi.yaxis[0].min = parseFloat(self.data_1.manual_min);
              }
              if(isNaN(self.data_2.manual_max)) ;
              else {
                self.options.yaxis[1].max = parseFloat(self.data_2.manual_max);
                self.options_chi.yaxis[1].max = parseFloat(self.data_2.manual_max);
              }
              if(isNaN(self.data_2.manual_min)) ;
              else {
                self.options.yaxis[1].min = parseFloat(self.data_2.manual_min);
                self.options_chi.yaxis[1].min = parseFloat(self.data_2.manual_min);
              }
            }
            setTimeout(function(){
              
              if(response.data_1 == null) {
                self.series[0].data = [];
                self.series_chi[0].data = [];
              }
              else {
                self.series[0].data = response.data_1;
                self.series_chi[0].data = response.data_1;
              }
              if(response.data_2 == null || response.data_2==undefined) {
                self.series[1].data = [];
                self.series_chi[1].data = [];
              }
              else {
                self.series[1].data = response.data_2;
                self.series_chi[1].data = response.data_2;
              }
              
              if(self.$i18n.locale == 'tc'){
                self.$refs.realtimeChart.updateSeries(self.series_chi, false);
                self.$refs.realtimeChart.updateOptions(self.options_chi);
              }
              else {
                self.$refs.realtimeChart.updateSeries(self.series, false);
                self.$refs.realtimeChart.updateOptions(self.options);
              }
              self.loading = false;
            },500)
          }          
        });
    },
    clearChartMultiple(device_id, no_of_data, data, callback) {
      var self = this;
      apiService
        .clearChartMultiple(
          self.$store.state.current.school_id,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
          no_of_data,
          data
        )
        .then((response) => {
            self.getChartMultiple(device_id, self.selected_graph.length, self.selected_graph[0], self.selected_graph[1]);
        });
    },
    applyManualYAxis(type, nod=1){
      var self = this;
      if(type=="multiple"){
        if(nod==1){
          if(self.manual_yaxis){
            if(isNaN(self.data_1.max_input) || isNaN(self.data_1.min_input)) {
              self.data_1.manual_max = undefined;
              self.data_1.manual_min = undefined;
              self.options.yaxis = {
                min: undefined,
                max: undefined,
                title: {
                  text: self.graph_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
                }
              }
              self.options_chi.yaxis = {
                min: undefined,
                max: undefined,
                title: {
                  text: self.graph_chi_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
                }                
              }
            }
            else {
              self.data_1.manual_max = self.data_1.max_input;
              self.data_1.manual_min = self.data_1.min_input;
              self.options.yaxis = {
                min: parseFloat(self.data_1.manual_min),
                max: parseFloat(self.data_1.manual_max),
                title: {
                  text: self.graph_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
                }
              }
              self.options_chi.yaxis = {
                min: parseFloat(self.data_1.manual_min),
                max: parseFloat(self.data_1.manual_max),
                title: {
                  text: self.graph_chi_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
                }
              }
            }
          }
          else if(!self.manual_yaxis){
            self.data_1.manual_max = undefined;
            self.data_1.manual_min = undefined;
            self.data_2.manual_max = undefined;
            self.data_2.manual_min = undefined;
            self.options.yaxis = {
              min: undefined,
              max: undefined,
              title: {
                text: self.graph_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
              }
            }
            self.options_chi.yaxis = {
              min: undefined,
              max: undefined,
              title: {
                text: self.graph_chi_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
              }
            }
          }
          setTimeout(function(){            
            if(self.$i18n.locale == 'tc'){
              self.$refs.realtimeChart.updateOptions(self.options_chi);
            }
            else {
              self.$refs.realtimeChart.updateOptions(self.options);
            }
            self.loading = false;
          },500)
        }
        else if(nod==2){
          if(self.manual_yaxis){
            if(isNaN(self.data_1.max_input) || isNaN(self.data_1.min_input)) {
              self.data_1.manual_max = undefined;
              self.data_1.manual_min = undefined;

              self.options.yaxis[0].max = parseFloat(self.data_1.data_max);
              self.options_chi.yaxis[0].max = parseFloat(self.data_1.data_max);
              self.options.yaxis[0].min = parseFloat(self.data_1.data_min);
              self.options_chi.yaxis[0].min = parseFloat(self.data_1.data_min);
            }
            else {              
              self.data_1.manual_max = self.data_1.max_input;
              self.data_1.manual_min = self.data_1.min_input;

              self.options.yaxis[0].max = parseFloat(self.data_1.manual_max);
              self.options_chi.yaxis[0].max = parseFloat(self.data_1.manual_max);
              self.options.yaxis[0].min = parseFloat(self.data_1.manual_min);
              self.options_chi.yaxis[0].min = parseFloat(self.data_1.manual_min);
            }
            if(isNaN(self.data_2.max_input) || isNaN(self.data_2.min_input)) {
              self.data_2.manual_max = undefined;
              self.data_2.manual_min = undefined;

              self.options.yaxis[1].max = parseFloat(self.data_2.data_max);
              self.options_chi.yaxis[1].max = parseFloat(self.data_2.data_max);
              self.options.yaxis[1].min = parseFloat(self.data_2.data_min);
              self.options_chi.yaxis[1].min = parseFloat(self.data_2.data_min);
            }
            else {
              self.data_2.manual_max = self.data_2.max_input;
              self.data_2.manual_min = self.data_2.min_input;

              self.options.yaxis[1].max = parseFloat(self.data_2.manual_max);
              self.options_chi.yaxis[1].max = parseFloat(self.data_2.manual_max);
              self.options.yaxis[1].min = parseFloat(self.data_2.manual_min);
              self.options_chi.yaxis[1].min = parseFloat(self.data_2.manual_min);
            }
          }
          else if(!self.manual_yaxis){
            self.data_1.manual_max = undefined;
            self.data_1.manual_min = undefined;
            self.data_2.manual_max = undefined;
            self.data_2.manual_min = undefined;

            self.options.yaxis[0].max = parseFloat(self.data_1.data_max);
            self.options.yaxis[0].min = parseFloat(self.data_1.data_min);
            self.options.yaxis[1].max = parseFloat(self.data_2.data_max);
            self.options.yaxis[1].min = parseFloat(self.data_2.data_min);
            
            self.options_chi.yaxis[0].max = parseFloat(self.data_1.data_max);
            self.options_chi.yaxis[0].min = parseFloat(self.data_1.data_min);
            self.options_chi.yaxis[1].max = parseFloat(self.data_2.data_max);
            self.options_chi.yaxis[1].min = parseFloat(self.data_2.data_min);
          }
          setTimeout(function(){
            if(self.$i18n.locale == 'tc'){
              self.$refs.realtimeChart.updateOptions(self.options_chi);
            }
            else {
              self.$refs.realtimeChart.updateOptions(self.options);
            }
            self.loading = false;
          },500);
        }
      }
      else if(type="single"){

      }
    },
    changeOverride(bStatus, eStatus){
      var self = this;
      self.$emit("changeOverride", {bStatus: bStatus, eStatus: eStatus});
    },
    checkOverrided(){
      var self = this;
      apiService
        .checkOverride(
          self.$cookies.get('booking_id'),
          self.$cookies.get('school_id'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.bStatus=='AVAILABLE' && response.eStatus=="ACTIVE"){
            self.controlAuth=false;
          }
          else if(response.bStatus!="RESERVED" || response.eStatus!="ACTIVE"){
          // either booking or equipment is locked
            if(self.$cookies.get("role")=="player"){
              self.controlAuth=false;
              if(response.eStatus!="ACTIVE")
                self.$store.commit("showSnackBar", "This experiment set is on HOLD by Admin. You are not allowed to control the equipment.");
              else if(response.bStatus!="ACTIVE")
                self.$store.commit("showSnackBar", "Your booking has been SUSPENDED by Admin. You are not allowed to control the equipment.");
              self.changeOverride(response.bStatus, response.eStatus);
            }
            else {
              self.controlAuth=true;
            }
          }
          else {
          // either booking and equipment is active to player
            if(self.$cookies.get("role")=="player")
              self.controlAuth=true;
            else 
              self.controlAuth=false;
          }
        });
    },
    clientAction(type, device_id, command){
      var self = this;
      apiService
        .checkOverride(
          self.$cookies.get('booking_id'),
          self.$cookies.get('school_id'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {          
          if(response.bStatus=='AVAILABLE' && response.eStatus=="ACTIVE"){
            self.controlAuth=false;
            self.changeOverride(response.bStatus, response.eStatus);
          }
          else if(response.bStatus!="RESERVED" || response.eStatus!="ACTIVE"){
            // either booking or equipment is locked
            if(self.$cookies.get("role")=="player"){
              self.controlAuth=false;
              if(response.eStatus!="ACTIVE")
                self.$store.commit("showSnackBar", "This experiment set is on HOLD by Admin. You are not allowed to control the equipment.");
              else if(response.bStatus!="ACTIVE"){
                self.$store.commit("showSnackBar", "Your booking has been SUSPENDED by Admin. You are not allowed to control the equipment.");
              }
              self.changeOverride(response.bStatus, response.eStatus);
            }
            else if(self.$cookies.get("role")=="overrider"){
              self.controlAuth=true;
              if (type == "setCommand")
                self.clientSetCommand(device_id, command);
              else if(type == "setChart")
                self.clientRequestChart(device_id, command);
            }
            else {
              self.$store.commit("showSnackBar", "Authorization error. Please re-enter experiment via booking page");
              self.$cookies.remove('booking_id');
              self.$cookies.remove('role');
              self.$cookies.remove('session_token');
              self.$cookies.remove('end_at');
              self.$router.push(
                "/booking/" + self.school_id
              );
            }
          }
          else {
          // either booking and equipment is active to player
            if(self.$cookies.get("role")=="player") {
              apiGeneral
                .getUserInfo($cookies.get("username"))
                .then((response) => {
                  if($cookies.get("auth_token")==response.auth_token){
                    self.controlAuth=true;
                    if (type == "setCommand")
                      self.clientSetCommand(device_id, command);
                    else if(type == "setChart")
                      self.clientRequestChart(device_id, command);
                  }
                  else {
                    self.$store.commit("showSnackBar", "Your account has been logged in from other device. Please log in again for operations.");
                  }
                });
            }
            else if(self.$cookies.get("role")=="overrider") {
              self.controlAuth=false;
            }              
            else {
              self.$store.commit("showSnackBar", "Authorization error. Please re-enter experiment via booking page");
              self.$cookies.remove('booking_id');
              self.$cookies.remove('role');
              self.$cookies.remove('session_token');
              self.$cookies.remove('end_at');
              self.$router.push(
                "/booking/" + self.school_id
              );
            }
          }
        });
    },
    clientSetCommand(device_id, command, callback){
      var self = this;
      self.loop_flag = true;
      self.setCommand(device_id, command);
    },
    clientRequestChart(device_id, command){
      var self = this;
      self.loading = true;
      self.setCommand(device_id, command);
      self.inte = setInterval(function () {
        self.getValue(device_id, function () {
          if (self.api.value.chart_at >= self.api.command_set_at) {
            clearInterval(self.inte);
            self.getChart(device_id);
          }
        });
      }, 2000);
    },
    setCommand(device_id, command, callback) {
      var self = this;
      apiService
        .setCommand(
          self.$cookies.get("session_token"),
          self.$cookies.get("role"),
          self.$store.state.current.school_id,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
          command
        )
        .then((response) => {
        });
    },
    requestChart(device, command) {
      var self = this;
      self.loading = true;
      self.setCommand(device, command, function () {
        self.inte = setInterval(function () {
          self.getValue(device, function () {
            if (self.api.value.chart_at >= self.api.command_set_at) {
              clearInterval(self.inte);
              self.getChart(device);
            }
          });
        }, 2000);
      });
    },
    requestEngineeringChart(device, command) {
      var self = this;
      self.loading = true;
      self.setCommand(device, command, function () {
        self.inte = setInterval(function () {
          self.getValue(device, function () {
            if (self.api.value.chart_at >= self.api.command_set_at) {
              clearInterval(self.inte);
              self.getChart(device);
            }
          });
        }, 4000);
      });
    },    
    setSCANCommand(device, command) {
      var self = this;
      self.moving = true;
      self.setCommand(device, command, function () {
        self.inte = setInterval(function () {
          self.getValue(device, function () {
            if (self.api.value_set_at >= self.api.command_set_at) {
              clearInterval(self.inte);
              self.moving = false;
            }
          });
        }, 500);
      });
    },
    requestSCAN(device, command) {
      var self = this;
      self.loading = true;
      self.setCommand(device, command, function () {
        self.inte = setInterval(function () {
          self.getValue(device, function () {
            if (self.api.value.chart_at >= self.api.command_set_at) {
              clearInterval(self.inte);
              self.getChart(device);
            }
          });
        }, 4000);
      });
    },
    requestIGraph(device, command) {
      var self = this;
      self.loading = true;
      self.showScanResult = false;
      self.setCommand(device, command, function () {
        self.inte = setInterval(function () {
          self.getValue(device, function () {
            if (self.api.value.chart_at >= self.api.command_set_at) {
              clearInterval(self.inte);
              self.loading = false;
              self.showScanResult = true;
              self.position = self.api.value.position;
            }
          });
        }, 4000);

      });

    },
    boardGetValue(device_id, callback) {
      var self = this;
      apiService
        .boardGetValue(
          self.experiment_name,
          self.equipment_id,
          device_id
        )
        .then((response) => {
          self.api.value_got_at = response.value_got_at;
          self.api.value_set_at = response.value_set_at;
          self.api.command_got_at = response.command_got_at;
          self.api.command_set_at = response.command_set_at;
          if (response.value != '') {
            self.api.value = JSON.parse(response.value);
          }
          if (callback) {
            callback();
          }
        });
    },
    boardGetChart(device_id, data) {
      var self = this;
      apiService
        .boardGetChart(
          self.experiment_name,
          self.equipment_id,
          device_id,
          data
        )
        .then((response) => {
          self.series[(parseInt(data) - 1)].data = response;

          self.$refs.realtimeChart.updateSeries(self.series, false, true);
        });
    },
    boardGetChartFileLine(device_id, data) {
      var self = this;
      apiService
        .boardGetChartFileLine(
          self.experiment_name,
          self.equipment_id,
          device_id,
          data
        )
        .then((response) => {
          self.timer = parseInt(response) - 1;
        });
    },
    boardSetChart(device_id, equipment_id, data, chart) {
      var self = this;
      apiService
        .boardSetChart(
          self.experiment_name,
          self.$cookies.get("equipment_id"),
          device_id,
          temp,
          chart
        )
        .then((response) => {
        });
    },
    readDataFromFile(device_id) {
      var self = this;
      apiService
        .readDataFromFile(
          self.experiment_name,
          self.$cookies.get("equipment_id"),
          device_id
        )
        .then((response) => {
          //                self.api.chart = response;
          self.api.records = response;
        });
    },
    setDataToFile(records, device_id) {
      var self = this;
      apiService
        .setDataToFile(
          self.experiment_name,
          self.$cookies.get("equipment_id"),
          device_id,
          records
        )
        .then((response) => {
          //                self.api.chart = response;
        });
    },

    getBoardFilename(device_id, data) {
      var self = this;
      apiService
        .getBoardFilename(
          self.experiment_name,
          self.equipment_id,
        )
        .then((response) => {
          window.open(
            process.env.VUE_APP_BASE_URL +
            "/api/experiment/" +
            response.filename
          );
        });
    },

    getBoardPhotoName(experiment, equipment_id, light) {
      var self = this;
      apiService
        .getBoardPhotoName(
          experiment,
          equipment_id,
          light
        )
        .then((response) => {
          //                return  process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
          self.img_src[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
          if (response.filename != null) {
            self.api.img_src = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
            if (equipment_id == 'set_0') {
              self.api.img_src_0[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
            }
            else if (equipment_id == 'set_1') {
              self.api.img_src_1[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
            }
            else if (equipment_id == 'set_2') {
              self.api.img_src_2[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
            }
            else if (equipment_id == 'set_3') {
              self.api.img_src_3[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
            }
          }
        });
    },
    requestIGraphResult(device, command) {
      var self = this;
      self.loading = true;
      self.showScanResult = false;
      self.setCommand(device, command, function () {
        self.inte = setInterval(function () {
          self.getValue(device, function () {
            if (self.api.value.chart_at >= self.api.command_set_at) {
              clearInterval(self.inte);
              self.loading = false;
              self.showScanResult = true;
              self.position = self.api.value.position;
              self.getIGraphName();
            }
          });
        }, 4000);

      });

    },
    getIGraphName() {
      var self = this;
      apiService
        .getIGraphName(
          self.experiment_name,
          self.$cookies.get("equipment_id"),
        )
        .then((response) => {
          //                return  process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
          self.img_src = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;

        });
    },
    downloadZipExperimentData(device_id){
      var self = this;
      apiService
        .downloadZipExperimentData(
          self.$cookies.get('school_id'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
          device_id,
        )
        .then((response) => {
          if(response.status == "success"){
            window.open(process.env.VUE_APP_BASE_URL + "/api/iot/experiment/" + response.path);
          }
          else {
            alert(response.message);
          }
        });
    },
  },
  created() {
  }
}